import React, { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { RightCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'

function ProductCard(props) {
  const { t } = useTranslation()
  const {
    data: { img, title, subTitle, url, closed, coverImg },
  } = props

  const handleClickItem = useCallback(() => {
    if (url) {
      window.open(url)
    }
  }, [url])

  return (
    <div className={styles.Item} onClick={handleClickItem}>
      <div
        className={`${styles.ImageWrap} ${coverImg ? styles.WithCoverImg : ''}`}
      >
        <img src={img} className={styles.ProductImg} />
        {closed && <div className={styles.ImageCover}>{t('please wait')}</div>}
        {!!coverImg && <img className={styles.QRCode} src={coverImg} />}
      </div>
      <div className={styles.Footer}>
        <div className={styles.Left}>
          <div className={styles.Title}>{title}</div>
          <div className={styles.Abstract}>{subTitle}</div>
        </div>
        <div className={styles.Right}>
          {url && <RightCircleOutlined className={styles.Icon} />}
        </div>
      </div>
    </div>
  )
}

ProductCard.propTypes = {
  data: PropTypes.shape({
    img: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    url: PropTypes.string,
    closed: PropTypes.bool,
    coverImg: PropTypes.string,
  }).isRequired,
}

export default memo(ProductCard)
